import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const DOCUMENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.DocumentType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const DOCUMENTTYPE_CONFIG = {
  entityName: 'DocumentType',
  localizationKey: 'Controlling::Entity.DocumentType',
  fields: DOCUMENTTYPE_FIELDS,
  permission: 'GeneralPersons.DocumentTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Persons + MENU_NAME_SUFFIX,
};
